import { render, staticRenderFns } from "./provider-identification-updated-task-item.vue?vue&type=template&id=7a14719c&"
import script from "./provider-identification-updated-task-item.vue?vue&type=script&setup=true&lang=js&"
export * from "./provider-identification-updated-task-item.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports